export default "__VITE_ASSET__Dmmc_3ta__"